export default __webpack_public_path__ + "static/media/v4clogo.104edd97.svg";